module.exports = __webpack_public_path__ + "images/patterns/dark/StripeDiagonal.5ffecc7a1e7c961c0da7.svg";